'use client';

import React, { useEffect, useState } from 'react';
import { PromptCard } from '@/components/prompt-card';
import { Prompt2 } from '@/types/schema';

interface SimilarPromptsProps {
  promptId: string;
  category: string;
  tagIds: string[];
}

export function SimilarPrompts({ promptId, category, tagIds }: SimilarPromptsProps) {
  const [similarPrompts, setSimilarPrompts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSimilarPrompts = async () => {
      try {
        const response = await fetch(
          `/api/similar-prompts?promptId=${promptId}&category=${category}&tagIds=${tagIds.join(',')}&limit=4`
        );

        if (!response.ok) throw new Error('Failed to fetch similar prompts');

        const data = await response.json();
        setSimilarPrompts(data);
      } catch (error) {
        console.error('Error fetching similar prompts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSimilarPrompts();
  }, [promptId, category, tagIds]);

  if (loading) {
    return <p>Loading similar prompts...</p>;
  }

  if (similarPrompts.length === 0) {
    return <p>No similar prompts found.</p>;
  }

  return (
    <div>
        <div className='mb-6'>
          <h2 className='font-bold text-2xl mb-1'>Similar Prompts</h2>
          <p className='text-gray-500'>Highest matching free ChatGPT prompts to the current prompt.</p>
        </div>
        <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {similarPrompts.map((prompt:Prompt2) => (
            <PromptCard key={prompt._id} prompt={prompt} />
            ))}
        </div>
    </div>
  );
}
